export default __webpack_public_path__ + "static/media/042-family-1.447c1884.png";